import { css } from '@emotion/core'
import theme from 'Theme'
const { spacing, typography, colors, mixins } = theme
const { defaultButton } = mixins

export default () => {
  return css`   
    ${defaultButton(theme)}  
    min-width: 230px;
    background-color: ${colors.primary};
    color: ${colors.complementary.primary};    
    border: ${`1px solid ${colors.primary}`};         
    
    .buy-button__icon {
      fill: ${colors.white};
      height: ${typography.baseFontSize};
      width: ${typography.baseFontSize};
      margin-right: ${spacing.base_2}px;
    }
  `
}
